import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  functionMenuName: validationNotEmpty("Path to Certificate Signing Request File")
});
  